import React from 'react';
import { FormattedMessage } from 'react-intl';

import ChannelImage from '../../../containers/channelUtils/ChannelImage';
import Badge from '../../badge/Badge';
import RadioGroupVariantPicker from '../variantPickers/RadioGroupVariantPicker';
import DropdownVariantPicker from '../variantPickers/DropdownVariantPicker';
import Button from '../../button/Button';
import PrimaryButton from '../../button/PrimaryButton';
import ProductVariantContainer from '../../productVariants/ProductVariantContainer';
import ProductPurchaseOccurrence from '../productPurchaseOccurrence/ProductPurchaseOccurrence';
import ChannelToggle from '../../../containers/channelUtils/ChannelToggle';
import Pricing from '../../pricing/Pricing';

export default class ProductPurchaseCard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      productTotalCost: null,
      productOriginalTotalCost: null,
    };
  }

  onCostChange = (newCost, newOriginalCost) => {
    if (newOriginalCost) {
      this.setState({
        productTotalCost: newCost,
        productOriginalTotalCost: newOriginalCost,
      });
    } else {
      this.setState({
        productTotalCost: newCost,
      });
    }
  };

  render() {
    const {
      product,
      occurrences,
      selectedVariant,
      purchaseParams,
      eventParams,
      onChange,
      onNotAvailable,
      onPurchase,
      onQuickPurchase,
      purchaseLoading,
      quickPurchaseLoading,
    } = this.props;
    const { productTotalCost, productOriginalTotalCost } = this.state;
    const paramsError = purchaseParams.error || eventParams.error;

    return (
      <div className="product  product--full">
        {!onNotAvailable && typeof paramsError !== 'string' && productTotalCost && (
          <div className="product__fixed">
            <div className="product__total">
              <div className="product__total-title">
                <FormattedMessage id="page.product.total" />
              </div>
              <Pricing
                  small
                  accented
                  value={productTotalCost}
                  originalValue={productOriginalTotalCost === productTotalCost ? null : productOriginalTotalCost } />
            </div>

            <PrimaryButton
              big
              full
              onClick={onQuickPurchase}
              loading={quickPurchaseLoading}
              disabled={quickPurchaseLoading}
            >
              <FormattedMessage id="section.generic.buy-now" />
            </PrimaryButton>
          </div>
        )}

        <div className="product__image">
          <ChannelImage
            src={!!product.images.length && product.images[0]}
            width={540}
            height={340}
            alt={product.name}
          />
          {product.labels.length > 0 && <Badge type={product.labels[0].label} />}
        </div>

        <div className="product__channel">
          <ChannelToggle />
        </div>

        {product.variants.length > 1 && (
          <div className="product__variant">
            {product.variantSelectionWidget === 'radio_buttons' ? (
              <RadioGroupVariantPicker
                availableVariants={product.variants}
                selectedVariant={selectedVariant}
                onChange={(selectedVariant) => onChange({ selectedVariant })}
              />
            ) : (
              <DropdownVariantPicker
                availableVariants={product.variants}
                selectedVariant={selectedVariant}
                onChange={(selectedVariant) => onChange({ selectedVariant })}
              />
            )}
          </div>
        )}

        {occurrences && !!occurrences.length && (
          <ProductPurchaseOccurrence
            occurrences={occurrences}
            selectedVariant={selectedVariant}
            eventParams={eventParams}
            onChange={(eventParams) => onChange({ eventParams })}
          />
        )}

        <ProductVariantContainer
          variant={selectedVariant}
          options={selectedVariant.optionSet && selectedVariant.optionSet.options}
          onChange={(purchaseParams) => onChange({ purchaseParams })}
          onCostChange={this.onCostChange}
        />

        {onNotAvailable ? (
          <React.Fragment>
            <div className="product__error">
              <FormattedMessage id="page.product.error" />
            </div>
            <Button filled big full onClick={onNotAvailable}>
              <FormattedMessage id="section.generic.contact-support" />
            </Button>
          </React.Fragment>
        ) : typeof paramsError === 'string' ? (
          <Button big full disabled>
            <FormattedMessage id={paramsError} />
          </Button>
        ) : (
          <div className="product__buy-action">
            <Button
              big
              full
              mod="add-to-cart"
              onClick={onPurchase}
              loading={purchaseLoading}
              disabled={purchaseLoading}
            >
              <FormattedMessage id="section.generic.add-to-cart" />
            </Button>

            <PrimaryButton
              big
              full
              onClick={onQuickPurchase}
              loading={quickPurchaseLoading}
              disabled={quickPurchaseLoading}
            >
              <FormattedMessage id="section.generic.buy-now" />
            </PrimaryButton>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productPurchase/productPurchaseCard/ProductPurchaseCard.js